<template>
	<v-dialog v-model="dialog" persistent max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
			<v-tooltip bottom color="primary">
				<template v-slot:activator="{ on }">
					<v-icon small v-on="on">mdi-lead-pencil</v-icon>
				</template>
				<span>{{'modify model' | localize }}</span>
			</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-spacer></v-spacer>
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{'Modify the parameters of the model' | localize }} <span class="secondary--text"> {{ product.trademark.name }} {{ product.model }}</span>
			</v-card-title>
			<v-divider />
			<v-card-text class="black--text">
				<v-container grid-list-md>
					<v-form v-model="valid" ref="form" lazy-validation>
						<v-row>
							<v-col cols="12" sm="6" md="4">
								<v-text-field dense
									color="secondary"
									:label="'Material' | localize"
									v-model.number="material"
									name="material"
									type="text"
									:rules="[rules.number, rules.required]"
									@change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field dense
									color="secondary"
									:label="'Manufacturing' | localize"
									v-model.number="manufacturing"
									name="manufacturing"
									type="text"
									:rules="[rules.number, rules.required]"
									@change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field dense
									color="secondary"
									:label="'Variations' | localize"
									v-model.number="variations"
									name="variations"
									type="text"
									:rules="[rules.number, rules.required]"
									@change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="12" md="12">
								<v-select dense
									return-object
									:item-text="`text_${locale.split('-')[0]}`"
									v-model="selected"
									:items="features"
									:clearable=true
									color="secondary"
									item-color="secondary"
									:label="'Functional expansion' | localize"
									@change="onceMore()">
								</v-select>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
				<v-row v-if="error" justify="center" class="mx-2 error--text">{{'Error' | localize }} => {{ error }} &#128533;</v-row>
				<v-row class="text-start text-pre-wrap mx-2">{{message}}</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text
					class="text-capitalize"
					:loading="loading" 
					:disabled="!valid || loading || calculating || Boolean(error)"
					@click="calculate">
					{{'Calculate' | localize }}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="!calculating || Boolean(error)"
					@click="upgradeModel">
					{{'Save' | localize }}
				</v-btn>
				<v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
					{{'Close' | localize }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { UnitCost, UpgradeInvestments, UpgradeAvailabilityFrom } from '../../../functions/product';
import { getMonth, localeNumber, PromoCodeGenerator } from '../../../functions/common';
import localizeFilter from '../../../filters/localize.filter';

	export default {
		props: ['product'],
		data () {
			return	{
				dialog: false,
				valid: false,
				message: '',
				error: '',
				calculating: false,
				trademark: this.product.trademark,
				name: this.product.model,
				id: this.product.id,
				rules: {
					required: value => !!value || localizeFilter('required field'),
					number: v => /^[+]?[1-5]/.test(v) || localizeFilter('its expected number from 1 to 5')
				},
				material: this.product.material,
				manufacturing: this.product.manufacturing,
				advanced_feature: {
					text_en: ''
				},
				variations: this.product.variations,
			
				investments: 0,
				unit_cost: 0,
				available_from: 1,
				available_till: 12,
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading;
			},
			locale() {
				return this.$store.getters.locale;
			},
			products() {
				return this.$store.getters.products;
			},
			features() {
				return this.$store.getters.FEATURES;
			},
			selected: {
				get() {
					return this.advanced_feature
				},
				set(val) {
					return this.advanced_feature = val;
				}
			}
		},
		methods: {
			calculate () {
				if (this.$refs.form.validate()) {
					/* new model parameters 
						@unitCost
						@r&dInvestments
						@r&dTime (completion) 
					*/
					
					if (this.material == this.product.material &&
						this.manufacturing == this.product.manufacturing &&
						this.variations == this.product.variations &&
						this.advanced_feature?.text_en == this.product.advanced_feature) {

							return this.error = localizeFilter('no parameters have been changed');
					}
					/* the advansed feature is the same */
					if (this.advanced_feature.text_en == this.product.advanced_feature) {
						
						this.unit_cost = UnitCost(this.material, this.manufacturing, this.variations)
						
						this.investments = UpgradeInvestments(
							this.product.material,
							this.product.manufacturing,
							this.product.variations,
							this.product.design,
							this.material,
							this.manufacturing,
							this.variations)
						this.available_from = UpgradeAvailabilityFrom(
							this.material,
							this.manufacturing,
							this.product.variations,
							this.variations) //mat, man, v_prev, v, feature = 0
					}
					else {

						this.unit_cost = UnitCost(
							this.material,
							this.manufacturing,
							this.variations,
							this.advanced_feature.value);
						
						this.investments = UpgradeInvestments(
							this.product.material,
							this.product.manufacturing,
							this.product.variations,
							this.product.design,
							this.material,
							this.manufacturing,
							this.variations,
							this.advanced_feature.value);
							
						this.available_from = UpgradeAvailabilityFrom(
							this.material,
							this.manufacturing,
							this.product.variations,
							this.variations,
							this.advanced_feature.value);
					}

					if (this.locale == 'ro-RO') {
						this.message = `Vă rugăm să luați notă de parametrilor modelului modificat ${this.name}:

						disponibilă din luna: ${getMonth(this.available_from)}
						cheltuielile pentru dezvoltare: $${localeNumber(this.investments, this.locale)}
						cost unitar: $${this.unit_cost}
						--------------------------------------------------------
					Dacă sunteți de acord, apăsați butonul "Salvare", altfel - apăsați "Închide"`
					} 
					else if (this.locale == 'ru-RU') {
						this.message = `Пожалуйста, обратите внимание на параметры измененной модели ${this.name}:

						доступна с месяца: ${getMonth(this.available_from)}
						расходы на И&Р: $${localeNumber(this.investments, this.locale)}
						себестоимость единицы продукции: $${this.unit_cost}
						--------------------------------------------------------
					Согласны? Нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
					}
					else {
						this.message = `Please note of the modified model ${this.name} specifications:

						available from: ${getMonth(this.available_from)}
						R&D spendings: $${localeNumber(this.investments, this.locale)}
						unit cost: $${this.unit_cost}
						--------------------------------------------------------
					If you agree, press the button "Save", else - press "Close"`
				}
					this.calculating = true;
				}				
			},
			onceMore () {
				this.calculating = false
				this.message = ''
				this.error = ''
			},
			async upgradeModel () {
				
				//add upgraded model
				let af = '';
				if (this.advanced_feature?.text_en) {
					af = this.advanced_feature.text_en;
				}
				const id = '_' + PromoCodeGenerator(9);

				const prod = {
					gameId: this.product.gameId,
					round: this.product.round,
					productId: id,
					trademark: this.product.trademark.name,
					model: this.name + '_upgraded',
					available_from: this.available_from,
					available_till: this.available_till,
					material: this.material,
					manufacturing: this.manufacturing,
					design_type: this.product.design_type,
					design: this.product.design,
					variations: this.variations,
					advanced_feature: af,
					teamId: this.product.team.id,
					investments: this.investments,
					unit_cost: this.unit_cost,
				}

				/* console.log(prod)  */
				
				try {
					//add product
					await this.$store.dispatch('addTeamProduct', prod);
					this.closeDialog();
				}
				catch (error) {
					this.$store.dispatch('setError', error.message)//throw error
				}
				
				/*  edit old model */
				const suff = this.product.model.split('_')[0];
				const product = this.products?.find((prod) => (prod.model == suff && prod.trademarkId == this.product.trademarkId));
				if (product) {
					// edit old model
					const upgraded = {
						...product, available_till: this.available_from - 1 }
					/* console.log(upgraded)*/
					try {
						await this.$store.dispatch('editTeamProduct', upgraded);
					}
					catch (error) {
						await this.$store.dispatch('setError', error.message)
					} 
				}
				
				this.closeDialog(); 
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.calculating = false
				this.message = ''
				this.error = ''
				//props
				this.material = this.product.material
				this.manufacturing = this.product.manufacturing
				this.variations = this.product.variations
				if (this.product && this.features) {
					let val = this.features.find(item => item.text == this.product.advanced_feature)
					if (val) {
						val = val.value
						this.advanced_feature = {
							text: this.product.advanced_feature,
							value: val,
						}
					}
				}
				else {
					this.advanced_feature = {}
				}
			}
		},
		created() {
			if (this.product && this.features) {
				let val = this.features.find(item => item.text_en == this.product.advanced_feature)
				if(val) {
					this.advanced_feature = {
						text_en: this.product.advanced_feature,
						text_ro: val.text_ro,
						text_ru: val.text_ru,
						value: val.value,
					}
				}
			}
		}
	}
</script>
